export default __webpack_public_path__ + "static/media/669.050dc5f3.png";